import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  students: number;
  page: number;
  pages: number;
  pageSize: number;
  sizes: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export default function AnalyticsPagination({
  students,
  page,
  pages,
  pageSize,
  sizes,
  onPageChange,
  onPageSizeChange,
}: Props) {
  return (
    <div className="et-analytics-pagination">
      <span>{students} students</span>
      <nav
        className="et-analytics-page-controls"
        aria-label="Analytics table pagination"
      >
        <label>
          Students per page
          <select
            aria-label="Students per page"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
          >
            {sizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>
        <button
          type="button"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft size={16} />
        </button>
        <output aria-label="Current analytics page">
          {page} / {Math.max(1, pages)}
        </output>
        <button
          type="button"
          aria-label="Next page"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight size={16} />
        </button>
      </nav>
    </div>
  );
}
